import { __ } from '@wordpress/i18n';
import {
	useBlockProps,
	RichText,
} from '@wordpress/block-editor';
import { Button } from '@wordpress/components';
/**
 * Save function.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#save
 *
 * @return {WPElement} Element to render.
 */
export default function save ({attributes,className}){
        const {
        	shortcode,
        } = attributes;


        return(

	    	<div className="ptl-shortcode-block">
				<RichText.Content
					tagName="div"
					className= 'input-control blocks-shortcode-textarea ptl_shortcode_area'
					value= {shortcode}
				/>
	    	</div>
	        );
}